export enum InputType { TEXT, BOX, AREA, SWITCH, CHECK, DROPDOWN, PASSWORD, RADIO }